import { Component, Input, OnChanges, OnInit } from '@angular/core';
import {Player} from '../../../models/player';
import { UserService } from 'src/app/services/user.service';
import {ViewInfo} from '../../../models/user/view-info';
import { PfrDto } from '../../../modules/charts/models/pfr.dto';
import { getRandomInt } from '../../functions/get-random-int';

@Component({
  selector: 'app-player-hud',
  templateUrl: './player-hud.component.html',
  styleUrls: ['./player-hud.component.scss']
})
export class PlayerHudComponent implements OnInit, OnChanges {

  @Input() player: Player;
  @Input() viewInfo: ViewInfo;
  @Input() reverse: boolean;
  @Input() pfr: PfrDto;

  layoutCard: string;
  avatarId: number;
  randomPfr: number | null;

  constructor(private userService: UserService) { }

  ngOnChanges()  {
    if (this.pfr) {
      if (this.player.position === 'BB') {
        this.randomPfr = getRandomInt(this.pfr.bb.start, this.pfr.bb.finish)
      } else if (this.player.position === 'SB'){
        this.randomPfr = getRandomInt(this.pfr.sb.start, this.pfr.sb.finish)
      } else if (this.player.position === 'BTN'){
        this.randomPfr = getRandomInt(this.pfr.btn.start, this.pfr.btn.finish)
      }
    } else {
      this.randomPfr = null
    }
  }
  ngOnInit() {
    this.layoutCard = localStorage.getItem('layoutCard');
    this.avatarId = this.userService.getUser().settings.avatar;
  }

}
